import { PLACARD_COLORS } from '@cowell/shared';

import { useConfig } from '../state/hooks.js';
import { useConfigStore } from '../state/store.js';

export function PlacardColorPicker() {
  const config = useConfig();
  const setPlacardColor = useConfigStore((s) => s.setPlacardColor);

  return (
    <fieldset className="section">
      <legend className="section-legend">Placard (fabric) color</legend>

      <div className="swatches" role="radiogroup" aria-label="Placard color">
        {PLACARD_COLORS.map((c) => {
          const selected = config.placardColorId === c.id;
          return (
            <button
              key={c.id}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={`${c.displayName}${c.isPattern ? ' (pattern)' : ''}`}
              title={c.displayName}
              className={`swatch${selected ? ' swatch--selected' : ''}${c.isPattern ? ' swatch--pattern' : ''}`}
              onClick={() => setPlacardColor(c.id)}
            >
              <span
                className="swatch__color"
                style={{ backgroundColor: c.hex }}
                aria-hidden="true"
              />
              <span className="swatch__name">{c.displayName}</span>
              {c.isPattern ? (
                <span className="swatch__badge" aria-hidden="true">
                  pattern
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
